const props = ["marginTop", "marginBottom", "borderTop", "borderBottom"];

export default function outerHeight(el, styles) {
  styles = styles || window.getComputedStyle(el);

  let height = el.clientHeight;

  props.map((prop) => {
    return (height += parseInt(styles[prop] || 0, 10));
  });

  return height;
}
